import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { BrandNotificationsSection } from '../components/brand-notifications-section.js';

const parentRoute = getRouteApi('/brand/$slug/settings');

export const Route = createFileRoute('/brand/$slug/settings/notifications')({
  component: ChannelsPage,
});

function ChannelsPage() {
  const { brand } = parentRoute.useLoaderData();
  return (
    // ConnectTelegramSection used to render here, after the whole
    // notifications section — which is why the telegram card appeared
    // below quiet hours, two scroll-screens from the other channel
    // setup. It now renders inside the channels block (spec 1151ae36).
    <BrandNotificationsSection brand={brand} />
  );
}
